import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'while_time',
    colour: CATEGORIES.control.color,
    tooltip: '指定した時間だけ繰り返します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('WHILE', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'DURATION',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1000 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'UNIT',
                    instance: () =>
                        new FieldOperatorDropdown([
                            { value: 'ms', label: 'ミリ秒', tooltip: '[1/1,000 秒]' },
                            { value: 's', label: '秒', tooltip: '[1 秒]' },
                        ]),
                },
                { type: 'label', text: '間くりかえす ' },
            ],
        },
        {
            kind: 'statement',
            name: 'DO',
        },
    ],
});
